<template>
    <editor
        :api-key="apiKey"
        @input="handleInput"
        :init="editorConfig"
    />
</template>
<script>
import Editor from '@tinymce/tinymce-vue'
import {usePage} from "@inertiajs/inertia-vue3";

export default {
    components: {
        "editor": Editor
    },
    data() {
        return {
            editorConfig: {
                menubar: false,
                statusbar: false,
                plugins: [
                    "autoresize advlist autolink lists image link charmap preview",
                    "searchreplace visualblocks fullscreen",
                    "insertdatetime table help code"
                ],
                toolbar: "undo redo | formatselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent preview | removeformat code | image link | help",
                toolbar_sticky: true,
            }
        };
    },
    props: {
        initialValue:
            {
                type: String,
                default: null
            },
        id: {
            type: String,
            default: null
        },
        height: {
            type: String,
            default: "100%"
        }
    },
    computed: {
        apiKey() {
            return usePage().props.value.tinymce.api_key;
        }
    },
    methods: {
        handleInput (value) {
            this.$emit('input', value)
        },
        handleError (err) {
            console.error(err)
        }
    }
}
</script>
